import {
  DefenseAccessAuthorityTypes,
  DefenseBrandMotorVehiclesTypes,
  DefenseEventTypes,
  DefenseVehicleAccessTypes,
  DefenseVehicleColorsTypes,
  IDefenseEventNotifyVehicleCaptureProps,
} from '../../../../services/Defense/Events/types';
import { Grid2 } from '@mui/material';
import TextFieldComponent from '../../../../components/TextFieldComponent';
import {
  convertAccessAuthorityType,
  convertBrandMotorVehicle,
  convertEventType,
  convertVehicleAccessType,
  convertVehicleColor,
} from '../../../../converters/Defense/ConverterDefense';
import React from 'react';
import TableComponent, {
  IColumnProps,
} from '../../../../components/TableComponent';
import dayjs from 'dayjs';
import DateFieldComponent from '../../../../components/DateFieldComponent';

interface IDefenseNotifyVehicleCaptureInfosContentProps {
  event: IDefenseEventNotifyVehicleCaptureProps;
}

const DefenseNotifyVehicleCaptureInfosContent = ({
  event,
}: IDefenseNotifyVehicleCaptureInfosContentProps) => {
  const columns: IColumnProps[] = [
    {
      id: 'groupId',
      label: 'ID',
      width: 'auto',
    },
    {
      id: 'groupName',
      label: 'Nome',
      width: 'auto',
    },
    {
      id: 'groupColor',
      label: 'Cor',
      width: 'auto',
    },
  ];

  const formatCreatedAt = (date: Date) => {
    return dayjs(date, 'YYYY/MM/DD HH:mm:ss');
  };

  return (
    <Grid2
      container
      direction={{ xs: 'column', lg: 'row' }}
      size={12}
      spacing={{ xs: 0, lg: 3 }}
      justifyContent={'center'}
      alignItems={{ xs: 'center', lg: 'normal' }}
    >
      <Grid2 size={{ xs: 12, lg: 6 }}>
        <TextFieldComponent
          label="Dispositivo"
          value={event?.device?.name ?? 'Não Possui'}
          type={'text'}
          slotProps={{
            inputLabel: {
              shrink: true,
            },
          }}
        />
        <TextFieldComponent
          label="Tipo"
          value={
            convertEventType(event.type as DefenseEventTypes) ?? 'Não Possui'
          }
          type={'text'}
          slotProps={{
            inputLabel: {
              shrink: true,
            },
          }}
        />
        <DateFieldComponent
          label="Data/Hora"
          value={formatCreatedAt(event.createdAt)}
          readOnly={true}
        />
        <TextFieldComponent
          label="ID da Vaga do Estacionamento"
          value={event?.parkingLotId ?? 'Não Possui'}
          type={'text'}
          slotProps={{
            inputLabel: {
              shrink: true,
            },
          }}
        />
        <TextFieldComponent
          label="Nome da Vaga do Estacionamento"
          value={event?.parkingLotName ?? 'Não Possui'}
          type={'text'}
          slotProps={{
            inputLabel: {
              shrink: true,
            },
          }}
        />
        <TextFieldComponent
          label="Data/Hora do Estacionamento na Vaga"
          value={event?.parkingTime.toString() ?? 'Não Possui'}
          type={'text'}
          slotProps={{
            inputLabel: {
              shrink: true,
            },
          }}
        />
        <TextFieldComponent
          label="ID da Posição"
          value={event?.positionId ?? 'Não Possui'}
          type={'text'}
          slotProps={{
            inputLabel: {
              shrink: true,
            },
          }}
        />
        <TextFieldComponent
          label="Nome da Posição"
          value={event?.positionName ?? 'Não Possui'}
          type={'text'}
          slotProps={{
            inputLabel: {
              shrink: true,
            },
          }}
        />
        <TextFieldComponent
          label="ID do Ponto"
          value={event?.pointId ?? 'Não Possui'}
          type={'text'}
          slotProps={{
            inputLabel: {
              shrink: true,
            },
          }}
        />
        <TextFieldComponent
          label="Nome do Ponto"
          value={event?.pointName ?? 'Não Possui'}
          type={'text'}
          slotProps={{
            inputLabel: {
              shrink: true,
            },
          }}
        />
        <TextFieldComponent
          label="ID do Canal"
          value={event?.channelId ?? 'Não Possui'}
          type={'text'}
          slotProps={{
            inputLabel: {
              shrink: true,
            },
          }}
        />
        <TextFieldComponent
          label="Nome do Canal"
          value={event?.channelName ?? 'Não Possui'}
          type={'text'}
          slotProps={{
            inputLabel: {
              shrink: true,
            },
          }}
        />
        <TextFieldComponent
          label="Data/Hora da Captura"
          value={event?.captureTime.toString() ?? 'Não Possui'}
          type={'text'}
          slotProps={{
            inputLabel: {
              shrink: true,
            },
          }}
        />
        <TextFieldComponent
          label="Placa"
          value={event?.plateNumber ?? 'Não Possui'}
          type={'text'}
          slotProps={{
            inputLabel: {
              shrink: true,
            },
          }}
        />
        <TextFieldComponent
          label="Placa Original"
          value={event?.originalPlateNumber ?? 'Não Possui'}
          type={'text'}
          slotProps={{
            inputLabel: {
              shrink: true,
            },
          }}
        />
      </Grid2>

      <Grid2 size={{ xs: 12, lg: 6 }}>
        <TextFieldComponent
          label="Identificação Aproximada"
          value={(event?.isFuzzy ? 'Sim' : 'Não') ?? 'Não Possui'}
          type={'text'}
          slotProps={{
            inputLabel: {
              shrink: true,
            },
          }}
        />
        <TextFieldComponent
          label="Autorização de Acesso"
          value={
            convertAccessAuthorityType(
              event.accessAuthority as DefenseAccessAuthorityTypes,
            ) ?? 'Não Possui'
          }
          type={'text'}
          slotProps={{
            inputLabel: {
              shrink: true,
            },
          }}
        />
        <TextFieldComponent
          label="Marca do Veículo"
          value={
            convertBrandMotorVehicle(
              event.vehicleBrand as DefenseBrandMotorVehiclesTypes,
            ) ?? 'Não Possui'
          }
          type={'text'}
          slotProps={{
            inputLabel: {
              shrink: true,
            },
          }}
        />
        <TextFieldComponent
          label="Cor do Veículo"
          value={
            convertVehicleColor(
              event.vehicleColor as DefenseVehicleColorsTypes,
            ) ?? 'Não Possui'
          }
          type={'text'}
          slotProps={{
            inputLabel: {
              shrink: true,
            },
          }}
        />
        <TextFieldComponent
          label="ID da Pessoa"
          value={event?.personId ?? 'Não Possui'}
          type={'text'}
          slotProps={{
            inputLabel: {
              shrink: true,
            },
          }}
        />
        <TextFieldComponent
          label="Nome da Pessoa"
          value={event.personName ?? 'Não Possui'}
          type={'text'}
          slotProps={{
            inputLabel: {
              shrink: true,
            },
          }}
        />
        <TextFieldComponent
          label="Compania/Empresa"
          value={event.companyName ?? 'Não Possui'}
          type={'text'}
          slotProps={{
            inputLabel: {
              shrink: true,
            },
          }}
        />
        <TextFieldComponent
          label="Código da Organização"
          value={event.organizationCode ?? 'Não Possui'}
          type={'text'}
          slotProps={{
            inputLabel: {
              shrink: true,
            },
          }}
        />
        <TextFieldComponent
          label="Nome da Organização"
          value={event.organizationName ?? 'Não Possui'}
          type={'text'}
          slotProps={{
            inputLabel: {
              shrink: true,
            },
          }}
        />
        <TextFieldComponent
          label="Tipo de A"
          value={
            convertVehicleAccessType(
              event.vehicleType as DefenseVehicleAccessTypes,
            ) ?? 'Não Possui'
          }
          type={'text'}
          slotProps={{
            inputLabel: {
              shrink: true,
            },
          }}
        />
        <TextFieldComponent
          label="Último ID de Captura de Veículo"
          value={event.lastEnterRecordId ?? 'Não Possui'}
          type={'text'}
          slotProps={{
            inputLabel: {
              shrink: true,
            },
          }}
        />
        <TextFieldComponent
          label="Último ID de Captura de Veículo"
          value={(event.isReleased ? 'Sim' : 'Não') ?? 'Não Possui'}
          type={'text'}
          slotProps={{
            inputLabel: {
              shrink: true,
            },
          }}
        />
        <TextFieldComponent
          label="Descrição"
          value={event.description ?? 'Não Possui'}
          type={'text'}
          slotProps={{
            inputLabel: {
              shrink: true,
            },
          }}
          multiline
        />
      </Grid2>
      {event.entranceGroups && event.entranceGroups.length > 0 && (
        <TableComponent rows={event.entranceGroups} columns={columns} />
      )}
    </Grid2>
  );
};

export default DefenseNotifyVehicleCaptureInfosContent;
